export default "__VITE_ASSET__CIPAP63$__"